import { defineComponent as _defineComponent } from 'vue'
import {
  ContentDisplay,
  ListDisplay,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';

import {
  CustomOperation,
  CustomOperationDetailLine
} from '@/modules/trade/services/custom-operations';
interface Props {
  customOperationData: CustomOperation;
  toggleDynamicModal: (row: CustomOperationDetailLine) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OperationData',
  props: {
    customOperationData: null,
    toggleDynamicModal: null
  },
  setup(__props: any) {



return { __sfc: true,ContentDisplay, ListDisplay, HeadingDisplay }
}

})